module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/plan4-2-72e97dd47d4330d81f96e001707d0566.webp";